import { SET_ITEMS, SET_TEMPLATES } from "../actions/types"


const INITIAL_STATE = {
  items: null,
  templates: null

}

const ItemsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_ITEMS:
      return { ...state, items: action.items }
    case SET_TEMPLATES:
      return { ...state, templates: action.items }
    default:
      return state
  }
};

export default ItemsReducer;
